// src/LinkIcon.tsx
import { jsx } from "react/jsx-runtime";
var LinkIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M4.91478 14.5249C3.22964 14.5249 1.71043 13.5098 1.06545 11.953C0.420467 10.3962 0.776722 8.60412 1.96811 7.41237L3.73645 5.64404L4.91478 6.82237L3.14728 8.58987C2.51566 9.22149 2.26899 10.1421 2.50018 11.0049C2.73136 11.8677 3.40529 12.5416 4.26809 12.7728C5.1309 13.004 6.0515 12.7573 6.68311 12.1257L8.45061 10.3582L9.62894 11.5374L7.86145 13.3049C7.08151 14.0886 6.02049 14.5279 4.91478 14.5249ZM5.50394 10.9474L4.32561 9.76904L10.2181 3.87654L11.3964 5.05487L5.50478 10.9465L5.50394 10.9474ZM11.9864 9.17987L10.8073 8.00154L12.5748 6.23404C13.215 5.60431 13.4683 4.67959 13.2383 3.81152C13.0083 2.94345 12.3305 2.26541 11.4625 2.03524C10.5944 1.80507 9.66965 2.05814 9.03978 2.6982L7.27145 4.4657L6.09311 3.28737L7.86145 1.51904C9.49068 -0.0959912 12.1189 -0.0902359 13.7411 1.53191C15.3632 3.15406 15.369 5.7823 13.7539 7.41154L11.9864 9.17904V9.17987Z" })
  }
);
var LinkIcon_default = LinkIcon;

export {
  LinkIcon_default
};
